
export function inlineJsonProps(obj, depth=0) {
  //console.log("DEPTH: ",depth)
  for (const [key, value] of Object.entries(obj)) {
    try {
      // its a stringigied dict
      if(value.startsWith("{\"")) {
        obj[key]=JSON.parse(value);
      
      // its a stringigied array of dicts
      } else if(value.startsWith("[{\"")) {
        obj[key]=JSON.parse(value);
      }
    } catch(e) {
      // consume
    }
    //console.log("KEY:",key)
    let resolvedValue=obj[key];
    // if(['DataConfiguration','TargetDataset','SourceDatasets','Location'].indexOf(key)>=0) {
    //   console.log(`TYPEOF ${key}:`,(typeof resolvedValue), resolvedValue)
    // }
    if(depth>0 && (Array.isArray(resolvedValue) && resolvedValue !== null)) {
      // console.log("FOO2")
      obj[key]=resolvedValue.map(e => {
        if(typeof e === 'object' && e !== null) {
          return inlineJsonProps(e, depth-1);
        } else {
          return e;
        }
      });
    } else if(depth>0 && (typeof resolvedValue === 'object' && resolvedValue !== null)) {
      // console.log("FOO1")
      obj[key]=inlineJsonProps(resolvedValue, depth-1);
    }
  }
  return obj;
}
